import { render } from "./Container.vue?vue&type=template&id=3bc92be2&scoped=true"
const script = {}

import "./Container.vue?vue&type=style&index=0&id=3bc92be2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3bc92be2"

export default script